import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-driver-warning",
  "use": "icon-driver-warning-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-driver-warning\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.106 3.289 3.224 19.053a1 1 0 0 0 .894 1.447h15.764a1 1 0 0 0 .895-1.447L12.895 3.289a1 1 0 0 0-1.789 0Zm-.49 7.207a1.389 1.389 0 1 1 2.77 0l-.309 4.007a1.08 1.08 0 0 1-2.153 0l-.308-4.007ZM11 17.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z\" fill=\"#FE8600\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol